export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5223.c64a1197.jpg";